import React from 'react';
import PropTypes from 'prop-types';
import { useObserver } from 'mobx-react';

import { routeNode } from 'core/routing';

import { useRouterStore } from 'apps/hooks';
import { FourOhFour } from 'apps/fourOhFour';
import SharedFilePage from 'apps/share';
import { PlanMonitor } from 'apps/initiative/views/PlanMonitor';

const viewsMap = {
  '': null, // TODO - page showing all shared files (?)
  file: SharedFilePage,
};

const SharedFileSpace = props => {
  const { route, params } = useRouterStore();
  const { componentFromRoute } = props;

  const View = componentFromRoute();

  return useObserver(() => (
    <PlanMonitor>
      <View params={params} routeName={route.name} />
    </PlanMonitor>
  ));
};

SharedFileSpace.propTypes = {
  componentFromRoute: PropTypes.func,
};

export const ProfileSharedFileRouter = routeNode(
  'profile.shared',
  viewsMap,
  FourOhFour,
)(SharedFileSpace);

export const InitiativeSharedFileRouter = routeNode(
  'initiative.shared',
  viewsMap,
  FourOhFour,
)(SharedFileSpace);
